const { DEV, PROD } = import.meta.env;
export { DEV, PROD };
